import Vue from 'vue'
import { API_ROOT } from '@/config'

const contextPath = 'item-dispatch'

export default (<any>Vue).resource(API_ROOT + contextPath + '{/id}', {})
